module.exports = "/assets/archetype-confidence.webp"